
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investor/filings",
      function () {
        return require("private-next-pages/investor/filings.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investor/filings"])
      });
    }
  